<template>
  <div>
    <h1>Admin Panel</h1>
    <div id="projects-admin-container">
      <div class="admin-menu-item">
        <router-link :to="{ name: 'IntegrationNumber' }"><i class="fa-solid fa-arrow-right"></i> Manage total amount integrations
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'IntegrationSummary' }"><i class="fa-solid fa-arrow-right"></i> Manage integration summary file
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'ClockifyReport' }"><i class="fa-solid fa-arrow-right"></i> Manage clockify report url
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'Users' }"><i class="fa-solid fa-arrow-right"></i> Manage users
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'AdminAgreement' }"><i class="fa-solid fa-arrow-right"></i> Manage agreements
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'ProjectConfig' }"><i class="fa-solid fa-arrow-right"></i> Manage jira project config
        </router-link>
      </div>
      <div class="admin-menu-item">
        <router-link :to="{ name: 'AdminTeams' }"><i class="fa-solid fa-arrow-right"></i> Manage teams
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      isLoaded: false
    };
  },
});
</script>

<style scoped lang="scss">
.admin-menu-item{
  margin-top: 10px;
  font-size: 15px;
  font-weight: bold;
  a {
    color: #273035;
  }
}
</style>
